<div class="widget">
    <h1 class="section-title title">About Us</h1>
    <p>Our mission is to serve our readers with news they trust.</p>
  </div>
